<template>
  <!-- A pledge card's head: a tinted circle with the frames' emoji and the card's
       title. Shared by the form (P1), the summary (D, V) and the FAST screen so they
       stay alike. The `icon` slot replaces the emoji where a frame draws an icon. -->
  <div class="flex items-center gap-[12px]">
    <span
      :class="[
        'size-[40px] shrink-0 rounded-full flex items-center justify-center text-[20px] leading-none',
        toneStyle.circle,
        muted && 'opacity-40 grayscale',
      ]"
      aria-hidden="true"
    >
      <slot name="icon">{{ toneStyle.emoji }}</slot>
    </span>
    <DsBody
      :class="[
        'text-[16px] leading-[22px] font-extrabold',
        muted ? 'text-grey-30' : 'text-campaign-ink',
      ]"
      ><slot
    /></DsBody>
  </div>
</template>

<script>
import { Body as DsBody } from '@team-hogc/hogc-one-design-system';
import { BF_PLEDGE_CARD_TONES as TONES } from '@/constants/MyGiving/building-fund-pledge';

export default {
  name: 'PledgeCardTitle',

  components: { DsBody },

  props: {
    tone: {
      type: String,
      default: 'months',
      validator: value => Object.keys(TONES).includes(value),
    },
    // A card that cannot be used right now (the other side of "one-time OR five
    // months" is filled in): faded icon, grey title.
    muted: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    toneStyle() {
      return TONES[this.tone];
    },
  },
};
</script>
